import React from 'react';
import { BasePage } from '@sm/webassets';

import SEO from '~pricing/components/SEO';
import useScript from '~pricing/hooks/useScripts';
import { EXTERNAL_SCRIPTS } from '~pricing/lib/constants';

import useMainStyles from './useStyles';

export default function Layout({ children }: { children: React.ReactElement }): JSX.Element {
  useScript(EXTERNAL_SCRIPTS);
  const { Main } = useMainStyles();

  return (
    <BasePage pageId="Pricing" legacyWeb="billweb" sticky={false}>
      <SEO>
        <main className={Main}>{children}</main>
      </SEO>
    </BasePage>
  );
}
